import React, { useState } from 'react'
import _ from 'lodash'
import { Row, Col, Avatar, Upload, Modal } from 'antd'
import Webcam from 'react-webcam'

const AvatarUpload = (props) => {
	const { 
		onChange, onCapture, visible, onCancel, isSaving, ...rest
	} = props

	const videoConstraints = {
		width: 720,
		height: 720,
		facingMode: 'user'
	}

	const [previewImage, setPreviewImage] = useState(null)
	const webcamRef = React.useRef(null)

	const capture = React.useCallback(
		() => {
		  const imageSrc = webcamRef.current.getScreenshot()
		  setPreviewImage(imageSrc)
		},
		[webcamRef]
	)

	return (
		<Modal
			{...rest}
			width='50%'
			// className='modal-confirm'
			visible={visible}
			onCancel={onCancel}
			onOk={() => onCapture(previewImage)}
			maskClosable={!isSaving}
			destroyOnClose
			okText='Confirm Photo'
			okButtonProps={{ disabled: !previewImage }}
			// footer={null}
		>
			<Row gutter={16}>
				<Col md={12} sm={24}>
					<Webcam
						audio={false}
						// height={720}
						ref={webcamRef}
						screenshotFormat="image/jpeg"
						// width={1280}
						width='100%'
						videoConstraints={videoConstraints}
					/>
				</Col>
				<Col md={12} sm={24}>
					<img src={previewImage} alt=''/>
				</Col>
			</Row>
			<Row style={{ textAlign: 'center', marginTop: 30 }}>
				<button className='btn btn-primary btn-rounded waves-effect waves-light' onClick={capture}>Capture photo</button>
			</Row>
		</Modal>
	)
}

export default AvatarUpload